import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import CONSTANT from './../../constant';

import Header from '../../component/common/Header';
import Paging from '../../component/common/Paging';
import FileSearchBar from './../../component/file/FileSearchBar';

import { getDateParts, getCookie } from '../../utils';
import { getApprovedFiles, getFileList } from './../../actions/FileAction';
import { getVersion } from './../../actions/MasterAction';


class ComponentName extends React.Component<any, any>{
    constructor(props: any) {
        super(props);
        const userDetail = getCookie(CONSTANT.cookie.userDetail);
        this.state = {
            page: 1,
            limit: 50,
            pending: undefined,
            list: undefined,
            userDetail,
            approvedFiles: []
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        document.title = CONSTANT.pageTitle.allFiles;

        this.loadList();
        getVersion().then((res: any) => {
            if (CONSTANT.version.web < res.web) {
                window.location.reload();
            }
        })
    }

    render() {
        const { page, list, userDetail, approvedFiles } = this.state;
        return (
            <div className="container-fluid">
                <div className="row">
                    {/* <div className="col-md-2 px-0">
                        <Header />
                    </div> */}
                    <div className="col-md-12 mb-3">
                        <div className='card homedob p-4 mb-4'>
                            <div className="row">
                                <div className="col-md-12 mt-3">
                                    <h3 className="page-title">Approved File(s)</h3>
                                    <div className="list-container">
                                        <div className='table-container'>
                                            <div className='table-wrapper'>
                                                <table className="tablen">
                                                    <thead>
                                                        <tr>
                                                            <th>S.No.</th>
                                                            <th scope="col" className='text-nowrap'>Pending with</th>
                                                            <th scope="col">Subject</th>
                                                            <th scope="col" className='text-nowrap'>File Number</th>
                                                            <th scope="col" className='text-nowrap'>Financial Implication</th>
                                                            <th scope="col" className='text-nowrap'>Created on</th>
                                                            <th scope="col" className='text-nowrap'>Modified on</th>
                                                            <th scope="col">Pending(Days)</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {/* ----------------------------------------------------------- */}

                                                        {
                                                            approvedFiles === undefined && <tr>
                                                                <td colSpan={8} className="text-center">Loading ...</td>
                                                            </tr>
                                                        }
                                                        {
                                                            approvedFiles !== undefined && approvedFiles?.length === 0 && <tr>
                                                                <td colSpan={8} className="text-center">No Record Found</td>
                                                            </tr>
                                                        }
                                                        {
                                                            approvedFiles !== undefined && approvedFiles.map((item: any, index: number) => {
                                                                const detailPageURL = CONSTANT.component.userFileDetail.url.replace(':code', item.fileCode);
                                                                const dated = getDateParts(item.dated);
                                                                const mo = getDateParts(item.modifiedOn);
                                                                const subjectStr = item.subject?.length > 50 ? item.subject.substr(0, 50) + '...' : item.subject;

                                                                const sd = moment(item.modifiedOn);//start date
                                                                const ed = moment();
                                                                const diff = Math.floor(moment.duration(ed.diff(sd)).asDays());
                                                                let diffCSSClassName = ""
                                                                if (diff >= 0 && diff <= 7) {
                                                                    diffCSSClassName = "text-primary"
                                                                } else if (diff > 7 && diff <= 14) {
                                                                    diffCSSClassName = "text-info"
                                                                } else if (diff > 14 && diff <= 21) {
                                                                    diffCSSClassName = "text-warning"
                                                                } else {
                                                                    diffCSSClassName = "text-danger"
                                                                }

                                                                return (
                                                                    <tr key={index} className="c-pointer" onClick={() => this.openDetailPage(detailPageURL)}>
                                                                        <td>{index + 1}</td>
                                                                        {
                                                                            (userDetail.isHOD || userDetail.code === item.createdBy) ? <td>
                                                                                {item.pendingWithName}
                                                                            </td> : <td>-</td>
                                                                        }
                                                                        <td>{subjectStr}</td>
                                                                        <td>{item.fileNumber}</td>
                                                                        <td>{item.financialImplication ? `${CONSTANT.static.currencySymbol} ${parseFloat(item.financialImplication).toLocaleString(CONSTANT.static.locale)}` : '-'}</td>
                                                                        <td>{`${dated.date} ${dated.monthName} ${dated.year}`}</td>
                                                                        <td>{`${mo.date} ${mo.monthName} ${mo.year}`}</td>
                                                                        <td className={diffCSSClassName}><b>{diff === 0 ? 'Updated Today' : diff}</b></td>
                                                                    </tr>
                                                                )
                                                            })
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>    
                                    </div>
                                </div>
                            </div>
                            {
                                list !== undefined && <Paging page={page} listItem={list} onPageChange={this.changePage} />
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    loadList = () => {
        const { page, limit } = this.state;
        getApprovedFiles(page, limit).then((res: any) => {
            this.setState({ approvedFiles: res.result });
        });
    }

    openDetailPage = (url: string) => {
        this.props.history.push(url);
    }

    changePage = (e: any) => {
        const type = e.target.dataset.type;
        const page = type === '+' ? this.state.page + 1 : this.state.page - 1;
        this.setState({ page }, () => { this.loadList() });
    }
}

export default ComponentName;